var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningBoltOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:lightning-bolt-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33333 6.31329V7.33329H9.84L8.66667 9.68663V8.66663H6.16L7.33333 6.31329ZM8.66667 0.666626L4 9.99996H7.33333V15.3333L12 5.99996H8.66667V0.666626Z",
    fill: "#7E86A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBoltOutline);
export default __webpack_public_path__ + "static/media/lightning-bolt-outline.3ee881f0f46aaad63c31a0d1e1fda87c.svg";
export { ForwardRef as ReactComponent };